export interface Notification {
  message: string;
  time: string;
  icon: string;
  color: string;
  status: string;
}

export interface NotificationHotel {
  id: number;
  name: string;
}

export interface NotificationCenter {
  uuid: string;
  title: string;
  titleKey?: string;
  body: string;
  type: NotificationType;
  priority: NotificationPriority;
  isRead: boolean;
  createdAt: string;
  actionUrl?: string;
  actionLabel?: string;
  hotel: NotificationHotel | null;
  deadlineAt?: string;
  timeAgo: string;
}

export enum NotificationType {
  BOOKING = 'booking',
  SECURITY = 'security',
  HOTEL_INFO = 'hotel_info',
  HOTEL_STATUS = 'hotel_status',
  HOTEL_SETTINGS = 'hotel_settings',
  SYSTEM = 'system'
}

export enum NotificationPriority {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
  URGENT = 'urgent'
}

/** Raw notification shape from the API (snake_case fields) */
export interface NotificationApiResponse {
  id: string;
  type: string;
  title: string;
  body: string;
  is_read: boolean;
  action_url: string | null;
  action_label: string | null;
  hotel: NotificationHotel | null;
  priority: string;
  deadline_at: string | null;
  time_ago: string;
  created_at: string;
}

/** Paginated list response from GET /v2/extranet/notifications?tab=...&page=... */
export interface PaginatedNotificationResponse {
  data: NotificationApiResponse[];
  links: {
    first: string;
    last: string;
    prev: string | null;
    next: string | null;
  };
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

/** Response from GET /v2/extranet/notifications/unread-count */
export interface UnreadCountResponse {
  unread_count: number;
}
